module.exports = __webpack_public_path__ + "img/title-1.f8686ba6.png";